// reCAPTCHA v3 Site Key
const SITE_KEY = '6Ld3Mx8sAAAAAEXjddRzNObCiYUB2GSEeN-j_E3O';

/**
 * Generate reCAPTCHA v3 token
 * @param {string} action - The action (login, register)
 * @returns {Promise<string>} - The reCAPTCHA token
 */
export async function generateRecaptchaToken(action = 'login') {
    return new Promise((resolve, reject) => {
        if (!window.grecaptcha) {
            reject(new Error('reCAPTCHA not loaded'));
            return;
        }

        window.grecaptcha.ready(async () => {
            try {
                const token = await window.grecaptcha.execute(SITE_KEY, { action });
                resolve(token);
            } catch (error) {
                reject(error);
            }
        });
    });
}